<template>
	<div>
		<div class="top_box">
			<h2>待认定保险责任案件</h2>
		</div>
		<div class="form_box">
			<el-table empty-text="暂无数据" :data="tableData" border>
				<el-table-column prop="number" label="序号" min-width="50"></el-table-column>
				<el-table-column prop="casenumber" label="案件编号" min-width="70"></el-table-column>
				<el-table-column prop="address" label="发生地点" min-width="140"></el-table-column>
				<el-table-column prop="username" label="用户姓名" min-width="60"></el-table-column>
				<el-table-column prop="phone" label="用户手机号" min-width="70"></el-table-column>
				<el-table-column prop="papers" label="证件信息" min-width="90"></el-table-column>
				<el-table-column prop="sex" label="性别" min-width="50"></el-table-column>
				<el-table-column prop="time" label="出险时间" min-width="90"></el-table-column>
				<el-table-column prop="par" label="用户保险详情" min-width="90">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">保险详情</el-button>
						<el-button type="text" size="small" v-show="!scope.row.isshow">无</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="plan" label="当前进度" min-width="60"></el-table-column>
				<el-table-column prop="node" label="当前节点" min-width="60"></el-table-column>
				<el-table-column label="处理单位">
					<template slot-scope="scope">
						<p v-for="item in scope.row.assigned">{{item.name}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="get_time" label="到达时间" min-width="90"></el-table-column>
				<el-table-column prop="op" label="操作" min-width="100">
					<template slot-scope="scope">
						<router-link :to="{name:'waitCaseSet',query:{caseId:scope.row.caseid,typeId: $route.query.typeId}}">认定保险责任</router-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import constants from '@/util/constants.js';
import { listAccessingCase } from '@/views/axios/api'
export default {
	data() {
		return {
			tableData: [],
			obj: [],
			victimList: [],
			token: this.$route.params.token || JSON.parse(window.localStorage.getItem('data')).data,
			typeId: this.$route.query.typeId,
			st_time: '',
			en_time: '',
			pickerOptions1: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			}
		};
	},
	methods: {
		topar(obj) {
			//this.$router.push("lookinf");
			this.$router.push({
				name: 'Reglookinf',
				params: {
					token: this.token
				},
				query: {
					typeId: this.typeId,
					caseid: obj
				}
			});
		},

		tores(obj) {
			this.$router.push({
				name: 'Regresstep',
				path: '/regulator/caseindex/resstep',
				params: {
					token: this.token
				},
				query: {
					typeId: this.$route.query.typeId,
					caseid: obj
				}
			});
		},
		toUrl(url) {
			window.open(url);
		},
		filt() {
			this.getData(this.st_time, this.en_time + 86400000);
		},
		sttime() {
			this.st_time = this.st_time * 1;
			// this.getData(this.st_time, 0);
			// console.log(this.st_time);
		},
		entime() {
			this.en_time = this.en_time * 1;
			// this.getData(0, this.en_time);
		},
		getData(st, et) {
			this.tableData = [];
			let that = this;
			let n = 0;
			let sex = '';
			let isshow = false;
      listAccessingCase({token:this.token})
				.then(data =>  {
          var data=data.data
					if (data.obj) {
						data.obj.map(v => {
							n = n + 1;
							if (v.victimList[0].obj.gender == '1') {
								sex = '男';
							} else {
								sex = '女';
							}
							if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != '') {
								isshow = true;
							} else {
								isshow = false;
							}
							var pt = constants.pt2txt3(v.obj.caseState);
							var address = '';
							if (v.generalLocation) {
								if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
									address = v.generalLocation.addr;
								} else {
									address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en');
								}
							}
							that.tableData.push({
								caseid: v.obj.id,
								number: n, //序号
								casenumber: v.obj.caseNo, //案件编号
								address, //地址
								username: v.victimList[0].obj.victimName, //姓名
								phone: v.obj.reporterContact, //联系方式
								papers: v.victimList[0].obj.idNo || '无', //身份证号
								sex: sex, //性别
								time: constants.time(v.obj.incidentTs), //出险时间
								insuranceUrl: v.insuranceUrl,
								plan: pt.phase, //进度
								node: pt.node, //节点
								get_time: constants.time(v.obj.incidentTs),
								op: '查看并操作',
								insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
								isshow: isshow,
								state: v.obj.caseState,
								assigned:v.assigned
							});
							that.caseid = v.obj.id;
							that.obj.push(v.obj);
							that.victimList.push(v.victimList[0]);
						});
					}
				});
		}
	},
	computed: {
		languageIndex() {
			return this.$store.state.language;
		}
	},
	watch: {
		languageIndex() {
			this.getData();
		}
	},
	mounted() {
		this.getData();
	}
};
</script>

<style scoped>
@import url('../../css/table.css');
</style>



// WEBPACK FOOTER //
// src/components/regulator/waitCase.vue